export const AUTH_USER = 'auth_user';
export const AUTH_ERROR = 'auth_error';
export const FETCH_ORDERS_REQ = 'fetch_orders_req';
export const FETCH_ORDERS_RES = 'fetch_orders_res';
export const TOGGLE_SIDENAV = 'toggle_sidenav';
export const UPDATE_ORDER_COMPLETED_TIME = 'update_order_completed_time';
export const UPDATE_ORDER_DELIVERED_TIME = 'update_order_delivered_time';
export const RECEIVE_WS_ORDERS = 'receive_ws_orders';
export const TIMER_START = 'timer_start';
export const TIMER_TICK = 'timer_tick';
export const TIMER_STOP = 'timer_stop';
export const FETCH_REPORT_REQ = 'fetch_report_req';
export const FETCH_REPORT_RES = 'fetch_report_res';
export const SUBMIT_REMAKE_REQ = 'submit_remake_req';
export const SUBMIT_REMAKE_SUCCESS = 'submit_remake_success';
export const SUBMIT_REMAKE_FAIL = 'submit_remake_fail';
export const FETCH_REMAKE_REPORT_REQ = 'fetch_remake_report_req';
export const FETCH_REMAKE_REPORT_RES = 'fetch_remake_report_res';
export const FETCH_TIP_REPORT_REQ = 'fetch_tip_report_req';
export const FETCH_TIP_REPORT_RES = 'fetch_tip_report_res';
export const FETCH_THROUGHPUT_REPORT_REQ = 'fetch_throughput_report_req';
export const FETCH_THROUGHPUT_REPORT_RES = 'fetch_throughput_report_res';
